import React, { useEffect, useCallback } from 'react';
import { reduxForm, Field, getFormValues } from 'redux-form';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { keyEnterSubmitForm } from '../../../utilities/FormUtils';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Button from '../../../control/button/Button';
import DatePicker from '../../../control/fdatetime/DateflatPicker';
import AutoComplete from '../../../control/autocomplete/AutoComplete';
import TextFields from '../../../control/textfield/TextFields';

const useStyles = makeStyles((theme) => ({
    spacing: {
        ...theme.form.spacing,
    },
    btnSearch: {
        width: '105px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    btnReset: {
        backgroundColor: `${theme.mainTheme.color6} !important`,
        width: '105px',
        marginRight: '8px',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            marginRight: '0px',
            marginBottom: '2%',
        },
    },
}));

const formId = 'TimeClockHistorySearchForm';

export const validateSearchForm = (values) => {
    const errorMsg = 'กรุณาระบุข้อมูล';
    const errors = {};
    if (!values.orgId) {
        errors.orgId = errorMsg;
    }
    if (!values.startDate) {
        errors.startDate = errorMsg;
    }
    if (!values.endDate) {
        errors.endDate = errorMsg;
    }
    if (moment(values.endDate).diff(moment(values.startDate), 'days') > 30) {
        errors.startDate =
            'กรุณาเลือกวันที่เริ่มต้นและวันที่สิ้นสุดไม่เกิน 1 เดือน';
    }
    return errors;
};

const SearchForm = ({
    handleSubmit,
    initialize,
    reset,
    change,
    defaultValues,
    lookups,
    showOrganization,
    onSubmit,
}) => {
    const classes = useStyles();
    const values = useSelector((state) => getFormValues(formId)(state));

    useEffect(() => {
        initialize({ ...defaultValues });
    }, []);

    const handleChangeDate = useCallback(
        (field) => (value) => {
            if (value) {
                switch (field) {
                    case 'startDate':
                        if (values.endDate && value > values.endDate) {
                            change('endDate', value);
                        }
                        break;
                    case 'endDate':
                        if (values.startDate && value < values.startDate) {
                            change('startDate', value);
                        }
                        break;
                    default:
                        break;
                }
            }
        },
        [values, change],
    );

    const handleClickReset = useCallback(() => {
        initialize({ ...defaultValues });
    }, [initialize, defaultValues]);

    const handleClickSearch = useCallback(() => {
        const _values = { ...values };
        if (!showOrganization) {
            delete _values.orgId;
        }
        onSubmit(_values);
    }, [showOrganization, onSubmit, values]);

    return (
        <Grid container spacing={1}>
            {showOrganization && (
                <Grid item xs={12} md={6} lg={4} className={classes.spacing}>
                    <Field
                        name="orgId"
                        label="หน่วยงาน"
                        component={AutoComplete}
                        optionKey={{
                            label: 'name',
                            value: 'orgId',
                            abbr: 'nameSht',
                        }}
                        required
                        options={lookups.organization}
                    />
                </Grid>
            )}
            <Grid item xs={12} md={6} lg={4} className={classes.spacing}>
                <Field
                    name="keyword"
                    label="รหัสพนักงานหรือชื่อ-นามสกุล"
                    component={TextFields}
                    placeholder="รหัสพนักงานหรือชื่อ-นามสกุลผู้บันทึกเวลา"
                    onKeyDown={keyEnterSubmitForm(
                        handleSubmit(handleClickSearch),
                    )}
                    maxLength={100}
                />
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={classes.spacing}>
                <Field
                    id="start-date-search-absence"
                    name="startDate"
                    label="วันที่เริ่มต้น"
                    component={DatePicker}
                    onChange={handleChangeDate('startDate')}
                    required
                />
            </Grid>
            <Grid item xs={12} md={3} lg={2} className={classes.spacing}>
                <Field
                    id="end-date-search-absence"
                    name="endDate"
                    label="วันที่สิ้นสุด"
                    component={DatePicker}
                    onChange={handleChangeDate('endDate')}
                    required
                />
            </Grid>
            {/* <Grid item xs={12} md={6} lg={4} className={classes.spacing}>
                <Field
                    name="dataTypeId"
                    label="ประเภทข้อมูล"
                    component={AutoComplete}
                    optionKey={{
                        value: 'id',
                        label: 'label',
                    }}
                    options={lookups.dataType}
                />
            </Grid> */}
            <Grid
                item
                xs={12}
                lg={8}
                container
                justify="flex-end"
                alignItems="center"
            >
                <Button
                    className={classes.btnReset}
                    onClick={handleClickReset}
                    label="ค่าเริ่มต้น"
                />
                <Button
                    className={classes.btnSearch}
                    onClick={handleSubmit(handleClickSearch)}
                    label="ค้นหา"
                />
            </Grid>
        </Grid>
    );
};

export default reduxForm({
    form: formId,
    validate: validateSearchForm,
})(SearchForm);
